// eslint-disable
// This file is generated dynamically through `node prepare-locales.js`. Please do content changes in `shopify/assets/locales/*.json`, update the filter rules in `prepare-locales.js` and run `node prepare-locales.js`.

import type { Locale } from './en'

if (!window.seebergerLocales) {
  window.seebergerLocales = {}
}

window.seebergerLocales.fi = {
  general: {
    forms: {
      response: {
        error: {
          text: 'Tarkista syötteesi ja yritä uudelleen. Seuraavissa kentissä on virheitä:',
        },
        success: {
          text: (data: { firstname: string; subject: string }) =>
            `Kiitos viestistäsi, ${data.firstname}. Otamme sinuun yhteyttä mahdollisimman pian aiheesta "${data.subject}".`,
        },
      },
    },
    links: {
      go_to: {
        product: (data: { productTitle: string }) =>
          `Lisätietoja tuotteesta ${data.productTitle}`,
        link: (data: { linkTitle: string }) =>
          `Lisätietoja aiheesta ${data.linkTitle}`,
      },
    },
  },
  accessibility: {
    close_notification: 'Sulje ilmoitus',
  },
  products: {
    product: {
      options: {
        more_single: 'Lisää',
        more_plural: 'Lisää (monikko)',
      },
      option_name: {
        pack: 'Pakkaus',
        pack_number: {
          '1_html': 'Yksittäistuote',
          '3_html': '3 kpl',
          '6_html': '6 kpl',
          '12_html': '12 kpl',
          '24_html': '24 kpl',
          default_html: (data: { count: string }) => `${data.count} kpl`,
        },
        discount_html: (data: { percent: string }) => `Säästä ${data.percent}%`,
      },
      colli_label: {
        default_html: (data: { count: string }) => `${data.count} kpl`,
      },
      add_to_cart: 'Lisää ostoskoriin',
      add_to_cart_sm: 'Lisää koriin',
      add_to_cart_title: (data: { productTitle: string }) =>
        `Lisää ${data.productTitle} ostoskoriin`,
      new: 'Uutuus',
      quantity: {
        input_label: (data: { product: string }) =>
          `Määrä tuotteelle ${data.product}`,
        increase: (data: { product: string }) =>
          `Lisää määrää tuotteelle ${data.product}`,
        decrease: (data: { product: string }) =>
          `Vähennä määrää tuotteelle ${data.product}`,
        limit_reached_error: (data: {
          totalRequestedQuantity: string
          maxAvailable: string
        }) =>
          `Toivottua määrää (${data.totalRequestedQuantity}) ei ole saatavilla. Maksimimäärä on ${data.maxAvailable}.`,
        limit_reached_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          availableMultipackQuantity: string
          maxAvailable: string
        }) =>
          `Toivottua määrää (${data.multiplicator}×${data.multipackQuantity}) ei ole saatavilla. Maksimimultipackien määrä on ${data.availableMultipackQuantity}×${data.multipackQuantity} tai yksittäin ${data.maxAvailable}.`,
        limit_reached_with_cart_items_error: (data: {
          requestedQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) =>
          `Toivottua määrää (${data.requestedQuantity}) ei ole saatavilla, koska ostoskorissasi on jo ${data.cartItemsCount} tuotetta. Kokonaismäärä on ${data.maxAvailable}.`,
        limit_reached_with_cart_items_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) =>
          `Toivottua määrää (${data.multiplicator}×${data.multipackQuantity}) ei ole saatavilla, koska ostoskorissasi on jo ${data.cartItemsCount} tuotetta. Kokonaismäärä yksittäisinä tuotteina on ${data.maxAvailable}.`,
        minimum_quantity_error: (data: { min: string }) =>
          `Sinun on tilattava vähintään ${data.min} tuotetta.`,
      },
      price: {
        from: 'Alkaen',
      },
      sold_out: 'Loppuunmyyty',
      diet_disclaimer:
        'Luonnollisesti sisältää ainesosia, mahdollinen ristikontaminaatio.',
      sugar_disclaimer: 'Sisältää luontaisesti sokeria.',
      salt_disclaimer: 'Sisältää luontaisesti suolaa.',
      nutrient_data: {
        title: 'Ravintosisältö',
        'title-average': 'Keskimääräinen ravintosisältö',
        'per-unit': '100 g',
        caloricvalue: 'Energia (kJ/kcal)',
        fat: 'Rasva',
        fat_of_which_saturates: 'joista tyydyttyneitä rasvoja',
        fat_of_which_mono_unsaturates:
          'joista kertatyydyttymättömiä rasvahappoja',
        carbohydrate: 'Hiilihydraatit',
        carbohydrate_of_which_sugars: 'joista sokereita',
        carbohydrate_of_which_polyols: 'joista polyoleja',
        carbohydrate_of_which_starch: 'joista tärkkelystä',
        fibre: 'Kuitu',
        protein: 'Proteiini',
        salt: 'Suola',
        vitamin_e: 'Vitamiini E',
        potassium: 'Kalium',
        chloride: 'Kloridi',
        calcium: 'Kalsium',
        phosphorus: 'Fosfori',
        omega_3_fatty_acids: 'Omega‑3‑rasvahapot',
        magnesium: 'Magnesium',
        iron: 'Rauta',
        zinc: 'Sinkki',
        copper: 'Kupari',
        manganese: 'Mangaani',
        fluoride: 'Fluoridi',
        selenium: 'Seleeni',
        chromium: 'Kromi',
        molybdenum: 'Molybdeeni',
        iodine: 'Jodi',
        fat_of_which_polyunsaturates: 'joista monityydyttymättömiä rasvoja',
        vitamin_a: 'Vitamiini A',
        vitamin_d: 'D-vitamiini',
        vitamin_k: 'K-vitamiini',
        vitamin_c: 'C-vitamiini',
        thiamin: 'Tiamiini',
        riboflavin: 'Riboflaviini',
        niacin: 'Niasiini',
        vitamin_b6: 'B6-vitamiini',
        folic_acid: 'Foolihappo',
        vitamin_b12: 'B12-vitamiini',
        biotin: 'Biotiini',
        pantothenic_acid: 'Pantoteenihappo',
      },
      'filter-p-m-seeberger-diet': {
        label: 'Ruokavalio',
        'gluten-free': 'gluteeniton',
        'lactose-free': 'laktoositon',
        vegan: 'vegaani',
        vegetarian: 'vegetaristinen',
        'no-added-sugar': 'ei lisättyä sokeria',
        'no-added-salt': 'ei lisättyä suolaa',
      },
    },
    facets: {
      filter_by_label: (data: { filter: string }) => `Suodata: ${data.filter}`,
    },
  },
  sections: {
    cart: {
      remove_title: (data: { title: string }) => `Poista ${data.title}`,
      presents: {
        button_label: 'Valitse lahja',
      },
    },
    'sb-popup-variant-overlay': {
      select_option: 'Valitse vaihtoehto',
      select_option_zustand: 'Kokonaiset pavut vai jauhettu?',
      select_option_inhalt: 'Kuinka paljon haluat?',
      select_option_packung: 'Kuinka monta pakkausta?',
      title: '',
    },
  },
  localization: {
    international: 'Kansainvälinen',
    country_section: 'Toimitusmaa',
    language_section: 'Kieli',
    country_section_desc: 'Valitse maa, johon haluat toimituksen.',
    language_section_desc: 'Valitse haluamasi kieli.',
    redirect_title: 'Uudelleenohjaus',
    redirect_message:
      'Sinut ohjataan pian valitulle kieliversiolle %selection%.',
    non_order_options: 'Valinta ilman tilaustoimintoa',
  },
  'customer-favorites': {
    'add-to-favorites': 'Lisää suosikkeihin',
    'remove-from-favorites': 'Poista suosikeista',
  },
  subscription: {
    discount_html: (data: { value: string }) => `Säästä ${data.value}`,
  },
} satisfies Locale
